import "@/App.css";
import { ReactLenis } from "lenis/react";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Products from "@/components/Products";
import Brands from "@/components/Brands";
import Manifesto from "@/components/Manifesto";
import Audiences from "@/components/Audiences";
import GruppiAcquisto from "@/components/GruppiAcquisto";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <div className="App bg-white text-ink selection:bg-ferrari">
          <Header />
          <main>
            <Hero />
            <Marquee />
            <Products />
            <Brands />
            <Manifesto />
            <Audiences />
            <GruppiAcquisto />
            <QuoteForm />
          </main>
          <Footer />
          <CookieBanner />
          <Toaster position="top-center" richColors />
        </div>
      </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
